export function init(widget:HTMLElement) {

  const body       = Array.from(document.getElementsByTagName('body'))[0] as HTMLBodyElement;
  const button     = widget.querySelector('.select-button')               as HTMLButtonElement;
  const info       = widget.querySelector('.select-info')                 as HTMLElement;
  const container  = widget.querySelector('.select-container')            as HTMLElement;
  const checkboxes = Array.from(widget.querySelectorAll('li input'))      as HTMLInputElement[];

  updateInfo(widget);

  // Send event about checked element (in order to update url model)
  checkboxes
    .filter(item => item.checked == true)
    .forEach(item => sendCheckboxEvent(widget, item, 'init'));

  // Menu open / close
  body     .addEventListener('click', event => closeMenu(event));
  button   .addEventListener('click', event => toggleMenu(event));
  info     .addEventListener('click', event => toggleMenu(event));
  container.addEventListener('click', event => event.stopPropagation());

  function toggleMenu(event: MouseEvent) {
    event.stopPropagation();
    container.classList.toggle('select-closed');
    button.classList.toggle('select-closed');
  }

  function closeMenu(event: MouseEvent) {
    event.stopPropagation();
    container.classList.add('select-closed');
    button.classList.add('select-closed');
  }

  // Click checkbox
  checkboxes.forEach(checkbox => {
    checkbox.addEventListener('click', event => {

      event.stopPropagation();

      // Clear all other checkboxes
      checkboxes
        .filter(item => item.id != checkbox.id)
        .forEach(item => item.checked = false);
        
      updateInfo(widget);
      sendCheckboxEvent(widget, checkbox, checkbox.checked);
    });
  });
}


function updateInfo(widget: HTMLElement) {

  const infoElement = document.getElementById('info-sort-widget') as HTMLElement;
  const infoText    = infoElement.querySelector('.select-info-text') as HTMLElement;
  const items       = Array.from(widget.querySelectorAll('li'));

  const selectedLabels = items
    .filter(item => item.querySelector('input').checked)
    .map   (item => item.querySelector('label').innerHTML);

  infoText.innerHTML =
    (selectedLabels.length > 0) ? selectedLabels[0] : infoElement.dataset.empty;
}


function sendCheckboxEvent(widget: HTMLElement, checkbox: HTMLInputElement, status: 'init' | boolean) {

  // Send checkbox event
  const checkboxEvent = new CustomEvent('sortCheckboxEvent', {
    bubbles: true,
    detail: {
      id        : checkbox.id.replace('checkbox-', ''),
      status    : status,
      parameter : checkbox.dataset.parameter,
    }
  });
  widget.dispatchEvent(checkboxEvent);

}

